import {useState} from "react";
import {host} from '../constants';

export const useMessages = () => {
    const [loading, setLoading] = useState(false);

    const sendBroadcast = async (token, message) => {
        setLoading(true);
        try {
            return await sendByHttp(token, message);
        } finally {
            setLoading(false);
        }
    };

    return {
        sendBroadcast,
        loading
    };
};

async function sendByHttp(token, message) {
    const url = host + '/api/Message';

    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(message)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to send broadcast');
    }

    return await response.json();
}